import { render, staticRenderFns } from "./PointsConfigModal.vue?vue&type=template&id=5f619843&scoped=true&"
import script from "./PointsConfigModal.vue?vue&type=script&lang=js&"
export * from "./PointsConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./PointsConfigModal.vue?vue&type=style&index=0&id=5f619843&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f619843",
  null
  
)

export default component.exports